import {
  DatePipe,
  isPlatformBrowser,
  NgTemplateOutlet,
} from '@angular/common';
import {
  Component,
  effect,
  inject,
  output,
  PLATFORM_ID,
  signal
} from '@angular/core';
import { Unsubscribe } from '@angular/fire/auth';
import { Router } from '@angular/router';
import { NgxTolgeeModule } from '@tolgee/ngx';
import { FirebaseFirestore } from '../../app.config';
import { DrawerService } from '../../drawer/drawer.service';
import { NotificationService } from '../../notification/notification.service';
import { ProductsComponent } from '../../products/products.component';
import { HoverGradientDirective } from '../../shared/directives/hover-gradient.directive';
import { Order } from '../../shared/model/order.model';
import { TimePipe } from '../../shared/pipes/time.pipe';
import { AccountService } from '../../shared/services/account.service';
import { AuthService } from '../../shared/services/auth.service';
import { NavigationService } from '../../shared/services/navigation.service';
import { ProductService } from '../../shared/services/product.service';
import { SiteService } from '../../shared/services/site.service';
import { VitalityPlanningComponent } from '../vitality-planning/vitality-planning';
import { RefillComponent } from './refill/refill.component';

@Component({
  selector: 'app-credits',
  templateUrl: 'credits.component.html',
  imports: [
    DatePipe,
    HoverGradientDirective,
    TimePipe,
    NgxTolgeeModule,
    NgTemplateOutlet
  ]
})
export class CreditsComponent {
  platformId = inject(PLATFORM_ID)
  authService = inject(AuthService);
  accountService = inject(AccountService);
  productService = inject(ProductService);
  navigationService = inject(NavigationService);
  notificationService = inject(NotificationService);
  siteService = inject(SiteService);
  drawerService = inject(DrawerService);
  firestore = inject(FirebaseFirestore);
  router = inject(Router);
  now = signal(new Date());
  onCancelSeance = output<void>();

  constructor() {
    if (isPlatformBrowser(inject(PLATFORM_ID))) {
      let first = true;
      effect(async () => {
        this.unsubscribeOrders();
        const user = this.authService.user()
        if (!user || !user.authCompleted) {
          return;
        }
        this.unsubscribeOrders = await this.firestore.onSnapshotCollection(`user/${user.uid}/orders`, async data => {
          if (first || (data as Order[]).every(o => o.state === 'processed')) {
            first = false;
            await this.accountService.refreshCredits()
          }
        });
      });
    }
  }

  /**
   * Go to offers is the user is on a center website else go home
   * @param target The erp code of the target product
   */
  creditMyCard(target: 'carte_tempo' | 'vitalite'): void {
    const center = this.siteService.center();
    if (center) {
      const products = target === 'carte_tempo' ?
        this.productService.reloadTempo() :
        this.productService.reloadVitality();
      if (products.length) {
        this.drawerService.open({
          component: ProductsComponent,
          inputs: { content: products },
          style: 'full'
        });
        return
      }
      const product = this.productService.ofCurrentCenter().find(p => p.erpCode === target)
      if (product) {
        this.navigationService.goTo(center, '/product/' + product.slug);
      } else {
        this.navigationService.goTo(center, '/offers');
      }
    } else {
      this.drawerService.open({
        component: RefillComponent,
        inputs: { target },
        style: 'full'
      });
    }
  }

  /**
   * Go to planning
   * @param mode mode
   */
  goToPlanning(mode: 'plan' | 'cancel'): void {
    this.drawerService.open({
      component: VitalityPlanningComponent,
      inputs: { mode },
      style: 'white',
      title: 'vitalityPlanningTitle'
    });
  }

  private unsubscribeOrders: Unsubscribe = () => {
  };
}
